<div class="flex-col-reverse flex md:flex-col h-full">

  <app-nav></app-nav>

  <div class="flex-1 overflow-y-auto bg-gray-50">
    <div class="max-w-2xl mx-auto px-4 py-6">
      <app-public-profile-card [corperSlug]="corperSlug"></app-public-profile-card>
    </div>
  </div>

</div>
